export default __webpack_public_path__ + "static/media/GL.f260d3a1.svg";